import Vue from 'vue'
import Vuex from 'vuex'
import { slice } from '@/util/object'

Vue.use(Vuex)

const keyUserManageConds = 'userManageConds'

const defaultUserManageConds = {
  sortType: false,
  page: 1,
  range: 0,
  cate_id: 0,
  keyword: ''
}

const state = {
  token: '',
  uname: '',
  title: '',
  logo: '',
  tel: '',
  head_color: '',
  isCeping: false,
  role: '',
  is_up_pack: 0,
  college_id: 0,
  is_super_pack: 0,
  pack_type_id: 0, // 1标准包。2升级包，3畅学包
  domain: '',
  isshow_icp: '',
  online_qiye_card: {},
  allow_drag_first: 0,
  strengthPwdCheck: 0,
  is_year_card: 0,
  user_is_year_card: 0,
  user_year_card_end_time: null,
  user_year_card_start_time: null,
  sdgh_lesson: 0,
  userManageConds: (() => {
    const json = localStorage.getItem(keyUserManageConds)
    const data = JSON.parse(json) || { ...defaultUserManageConds }
    return data
  })()
}

const mutations = {
  setValue(state, obj) {
    if (typeof obj === 'object') {
      Object.keys(obj).forEach(v => {
        state[v] = obj[v]
      })
    }
    let user = localStorage.getItem('user')
    user = JSON.parse(user)
    if (user) {
      state.role = user.role
      state.token = user.token
      state.uname = user.uname
    }
  },

  logout(state) {
    store.commit('setValue', {
      token: '',
      uname: '',
      role: '',
      isCeping: false
    })
  },

  setUserManageConds(state, value) {
    const keys = Object.keys(defaultUserManageConds)
    const data = slice(value, keys)
    state.userManageConds = data
    // 将查询条件保存在本地存储
    localStorage.setItem(keyUserManageConds, JSON.stringify(data))
  }
}

const store = new Vuex.Store({
  state,
  mutations
})

/**
 * 获取或设置课程库保存的搜索条件
 * @param value
 */
export function userManageConds(value) {
  if (value === undefined) {
    return store.state.userManageConds
  }
  store.commit('setUserManageConds', value)
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js